__turbopack_context__.v({
  "ctaItem": "styles-module__WFVCWG__ctaItem",
  "ctaLink": "styles-module__WFVCWG__ctaLink",
  "ctaList": "styles-module__WFVCWG__ctaList",
  "ctaNormal": "styles-module__WFVCWG__ctaNormal",
  "heading": "styles-module__WFVCWG__heading",
  "list": "styles-module__WFVCWG__list",
});
